import { apiClient } from '../httpClient';

// 파일 업로드 초기화
export const initUpload = async ({ filename, mimeType, size, tags }) => {
    const payload = {
        filename,
        mime_type: mimeType || 'application/octet-stream',
        size,
        tags: tags || {}
    };
    const response = await apiClient.post('/files/v1/files/init', payload);
    return response.data; // { file_id, upload_url, ... }
};

// 업로드 완료 콜백
export const completeUpload = async (fileId) => {
    const response = await apiClient.post(`/files/v1/files/${fileId}/complete`);
    return response.data;
};

// 파일 메타/다운로드 URL 조회
export const getFile = async (fileId) => {
    const response = await apiClient.get(`/files/v1/files/${fileId}`);
    return response.data; // { download_url, ... }
};

// order_id로 파일 목록 조회
export const getFilesByOrderId = async (orderId) => {
    const response = await apiClient.get('/files/v1/files', {
        params: {
            order_id: orderId
        }
    });
    return response.data; // [{ file_id, filename, download_url, ... }, ...]
};

// 기존 파일 삭제 요청
export const deleteFile = async (fileId) => {
    const response = await apiClient.post(`/files/v1/files/${fileId}/delete`);
    return response.data;
};

export const fileService = {
    initUpload,
    completeUpload,
    getFile,
    getFilesByOrderId,
    deleteFile
};
